import styled from 'styled-components';
import {
  Dropdown as SemanticDropdown,
  Grid as SemanticGrid,
  Modal as SemanticModal,
} from 'semantic-ui-react';

import { Button as ButtonLayoutComponent, Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

export const Container = styled.div`
  width: 100%;
  display: inline-block;
`;

export const CardContainer = styled.div`
  padding-top: 10px;
  display: inline-block;
`;

export const Text = styled(TextLayoutComponent)``;

export const Dropdown = styled(SemanticDropdown)`
  &.ui.selection.dropdown {
    margin-top: 9px;
  }
`;

export const Grid = styled(SemanticGrid)`
  &&& {
    margin: 0px;
    padding: 0px;
    text-align: center;
    width: 100%;
  }
`;

export const Row = styled(SemanticGrid.Row)`
  padding-top: 0px !important;
`;

export const Column = styled(SemanticGrid.Column)`
  text-align: left;
  min-width: 100px;
  padding-left: 0px !important;
  display: ${(props) => (props.hide ? 'none' : 'block')} !important;
`;

export const Link = styled.a``;

export const LinkContainer = styled.div`
  display: inline-block;
`;

export const Modal = styled(SemanticModal)``;

export const ContainerContent = styled(TextLayoutComponent.Header)`
  display: flex;
  align-items: center;
  flex-direction: column;
  font-size: 20px;
  padding: 50px;
`;

export const ContainerText = styled.div`
  margin-bottom: 6px;
  text-align: center;
`;

export const ContainerTextSize = styled(ContainerText)`
  font-size: 18px;
`;

export const Button = styled(ButtonLayoutComponent)`
  &.ui.button {
    width: ${({ oneButton }) => (oneButton ? '80px' : ' 190px')};
  }
`;

export const ButtonInverted = styled(ButtonLayoutComponent.Inverted)`
    &.ui.button {
    width: 190px;
  }
`;

export const ContainerButton = styled.div`
  display: flex;
  width: 100%;
  justify-content: ${({ oneButton }) => (oneButton ? 'center' : 'space-between')};
  margin-top: 20px;
`;
